import React from "react"
import * as styles from "./contact.module.css"
import Section from "./section"

export default function Contact() {
	return (
		<Section
			id="contact"
			className={styles.contact}
			wrapperClassName={styles.wrapper}
		>
			<h3>Get in touch</h3>
			<p>
				Say hello at <a href="mailto:hi@nateweiner.com">hi@nateweiner.com</a>
			</p>
		</Section>
	)
}
